import { render, staticRenderFns } from "./gant-board.vue?vue&type=template&id=08383068&scoped=true&"
import script from "./gant-board.vue?vue&type=script&lang=js&"
export * from "./gant-board.vue?vue&type=script&lang=js&"
import style0 from "./gant-board.vue?vue&type=style&index=0&id=08383068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08383068",
  null
  
)

export default component.exports